
export const FILTER_GLOW_ID = 'filter--glow';

export const FilterGlow: React.FC = () => (
  <filter id={FILTER_GLOW_ID} y="-40%" height="180%" x="-40%" width="180%">
    <feMorphology result="DILATED" operator="dilate" radius="1.5" />
    <feGaussianBlur in="DILATED" result="BLURRED" stdDeviation="24" />
    <feMerge>
      <feMergeNode in="BLURRED" />
      <feMergeNode in="SourceGraphic" />
    </feMerge>
  </filter>
);
